import { useState } from "react";
import { clinicInfo } from "../../mocks/home-data";
import FadeIn from "../../components/base/FadeIn";
import PageHero from "../../components/feature/PageHero";

export default function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    petType: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 3000);
  };

  return (
    <main>
      <PageHero
        badge="İletişim"
        title={
          <>
            Bize{" "}
            <span className="font-serif italic text-primary-300">Ulaşın</span>
          </>
        }
        description="Randevu almak, bilgi almak veya acil durumlar için bizi arayabilir ya da mesaj bırakabilirsiniz. Ekibimiz size yardımcı olmaktan mutluluk duyacaktır."
        backgroundImage="/assets/images/contact-hero-bg.jpg"

      />

      {/* Contact Content */}
      <section className="py-16 md:py-24 bg-white">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="max-w-7xl mx-auto">
            <div className="grid lg:grid-cols-2 gap-10 lg:gap-16">
              {/* Contact Info */}
              <div>
                <FadeIn>
                  <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8">İletişim Bilgileri</h2>
                </FadeIn>

                <div className="space-y-6">
                  <FadeIn delay={0.1}>
                    <div className="flex items-start gap-5 bg-cream-50 rounded-2xl p-6 transition-all hover:shadow-md">
                      <div className="w-14 h-14 rounded-xl bg-primary-100 flex items-center justify-center shrink-0">
                        <i className="ri-map-pin-line text-2xl text-primary-700 w-6 h-6 flex items-center justify-center" />
                      </div>
                      <div>
                        <p className="font-bold text-gray-900 mb-1">Adres</p>
                        <p className="text-gray-600 text-sm leading-relaxed">{clinicInfo.address}</p>
                        <a
                          href="https://maps.google.com/?q=Keçiören+Ankara"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 mt-2 font-medium"
                        >
                          <i className="ri-navigation-line w-4 h-4 flex items-center justify-center" />
                          Yol Tarifi Al
                        </a>
                      </div>
                    </div>
                  </FadeIn>

                  <FadeIn delay={0.15}>
                    <div className="flex items-start gap-5 bg-cream-50 rounded-2xl p-6 transition-all hover:shadow-md">
                      <div className="w-14 h-14 rounded-xl bg-primary-100 flex items-center justify-center shrink-0">
                        <i className="ri-phone-line text-2xl text-primary-700 w-6 h-6 flex items-center justify-center" />
                      </div>
                      <div>
                        <p className="font-bold text-gray-900 mb-1">Telefon</p>
                        <a href={`tel:${clinicInfo.phoneRaw}`} className="text-primary-600 hover:text-primary-700 text-lg font-semibold transition-colors">
                          {clinicInfo.phone}
                        </a>
                        <p className="text-gray-500 text-sm mt-1">Acil durumlar için arayabilirsiniz</p>
                      </div>
                    </div>
                  </FadeIn>

                  <FadeIn delay={0.2}>
                    <div className="flex items-start gap-5 bg-cream-50 rounded-2xl p-6 transition-all hover:shadow-md">
                      <div className="w-14 h-14 rounded-xl bg-primary-100 flex items-center justify-center shrink-0">
                        <i className="ri-time-line text-2xl text-primary-700 w-6 h-6 flex items-center justify-center" />
                      </div>
                      <div>
                        <p className="font-bold text-gray-900 mb-1">Çalışma Saatleri</p>
                        <p className="text-gray-700 text-sm">{clinicInfo.workingHours}</p>
                        <p className="text-gray-500 text-sm">{clinicInfo.sunday}</p>
                      </div>
                    </div>
                  </FadeIn>

                  <FadeIn delay={0.25}>
                    <div className="flex items-start gap-5 bg-cream-50 rounded-2xl p-6 transition-all hover:shadow-md">
                      <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-purple-500 via-pink-500 to-orange-400 flex items-center justify-center shrink-0">
                        <i className="ri-instagram-line text-2xl text-white w-6 h-6 flex items-center justify-center" />
                      </div>
                      <div>
                        <p className="font-bold text-gray-900 mb-2">Instagram</p>
                        <div className="flex flex-col gap-2">
                          <a
                            href={`https://instagram.com/${clinicInfo.instagram1}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 transition-colors font-medium"
                          >
                            <i className="ri-instagram-line w-4 h-4 flex items-center justify-center" />
                            @{clinicInfo.instagram1}
                          </a>
                          <a
                            href={`https://instagram.com/${clinicInfo.instagram2}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 transition-colors font-medium"
                          >
                            <i className="ri-instagram-line w-4 h-4 flex items-center justify-center" />
                            @{clinicInfo.instagram2}
                          </a>
                        </div>
                      </div>
                    </div>
                  </FadeIn>
                </div>

                {/* WhatsApp CTA */}
                <FadeIn delay={0.3}>
                  <div className="mt-8 p-7 bg-green-50 rounded-2xl border border-green-100">
                    <div className="flex items-center gap-4 mb-4">
                      <div className="w-14 h-14 rounded-xl bg-green-500 flex items-center justify-center">
                        <i className="ri-whatsapp-line text-2xl text-white w-6 h-6 flex items-center justify-center" />
                      </div>
                      <div>
                        <h3 className="font-bold text-gray-900 text-lg">WhatsApp Hattı</h3>
                        <p className="text-gray-600 text-sm">Hızlı iletişim için WhatsApp üzerinden bize ulaşabilirsiniz.</p>
                      </div>
                    </div>
                    <a
                      href="https://wa.me/905396960677"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2 px-6 py-3 bg-green-600 hover:bg-green-700 text-white font-semibold rounded-xl transition-all duration-300 whitespace-nowrap shadow-md hover:shadow-lg"
                    >
                      <i className="ri-whatsapp-line w-5 h-5 flex items-center justify-center" />
                      WhatsApp'tan Yaz
                    </a>
                  </div>
                </FadeIn>
              </div>

              {/* Contact Form */}
              <div>
                <FadeIn delay={0.2}>
                  <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8">Bize Yazın</h2>
                </FadeIn>
                <FadeIn delay={0.3}>
                  <div className="bg-cream-50 rounded-3xl p-7 md:p-8">
                    <form
                      action="https://readdy.ai/api/form/d7kbg6v44bvd703c8u10"
                      method="POST"
                      data-readdy-form
                      onSubmit={handleSubmit}
                      className="space-y-5"
                    >
                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">Adınız Soyadınız *</label>
                        <input
                          type="text"
                          name="name"
                          value={formData.name}
                          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                          className="w-full px-4 py-3.5 rounded-xl border border-gray-200 focus:border-primary-500 focus:ring-2 focus:ring-primary-200 outline-none transition-all text-sm bg-white"
                          placeholder="Adınızı girin"
                          required
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">E-posta *</label>
                        <input
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                          className="w-full px-4 py-3.5 rounded-xl border border-gray-200 focus:border-primary-500 focus:ring-2 focus:ring-primary-200 outline-none transition-all text-sm bg-white"
                          placeholder="E-posta adresiniz"
                          required
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">Telefon</label>
                        <input
                          type="tel"
                          name="phone"
                          value={formData.phone}
                          onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                          className="w-full px-4 py-3.5 rounded-xl border border-gray-200 focus:border-primary-500 focus:ring-2 focus:ring-primary-200 outline-none transition-all text-sm bg-white"
                          placeholder="Telefon numaranız"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">Evcil Hayvan Türü</label>
                        <select
                          name="petType"
                          value={formData.petType}
                          onChange={(e) => setFormData({ ...formData, petType: e.target.value })}
                          className="w-full px-4 py-3.5 rounded-xl border border-gray-200 focus:border-primary-500 focus:ring-2 focus:ring-primary-200 outline-none transition-all text-sm bg-white"
                        >
                          <option value="">Seçiniz</option>
                          <option value="kopek">Köpek</option>
                          <option value="kedi">Kedi</option>
                          <option value="kus">Kuş (Papağan, Kanarya, vb.)</option>
                          <option value="suringen">Sürüngen</option>
                          <option value="kemirgen">Kemirgen</option>
                          <option value="diger">Diğer</option>
                        </select>
                      </div>
                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">Mesajınız</label>
                        <textarea
                          name="message"
                          value={formData.message}
                          onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                          rows={4}
                          maxLength={500}
                          className="w-full px-4 py-3.5 rounded-xl border border-gray-200 focus:border-primary-500 focus:ring-2 focus:ring-primary-200 outline-none transition-all text-sm bg-white resize-none"
                          placeholder="Mesajınızı yazın (max 500 karakter)"
                        />
                        <p className="text-xs text-gray-400 mt-1 text-right">{formData.message.length}/500</p>
                      </div>
                      <button
                        type="submit"
                        className="w-full inline-flex items-center justify-center gap-2 px-6 py-4 bg-primary-600 hover:bg-primary-700 text-white font-bold rounded-xl transition-all duration-300 whitespace-nowrap shadow-md hover:shadow-lg hover:-translate-y-0.5"
                      >
                        <i className="ri-send-plane-line w-5 h-5 flex items-center justify-center" />
                        Gönder
                      </button>
                      {submitted && (
                        <div className="p-4 bg-green-50 border border-green-200 rounded-xl">
                          <p className="text-sm text-green-700 font-medium flex items-center gap-2">
                            <i className="ri-check-line w-5 h-5 flex items-center justify-center" />
                            Mesajınız alındı! En kısa sürede size dönüş yapacağız.
                          </p>
                        </div>
                      )}
                    </form>
                  </div>
                </FadeIn>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="py-16 md:py-20 bg-cream-50">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="max-w-7xl mx-auto">
            <FadeIn>
              <div className="text-center mb-10">
                <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3">Konum</h2>
                <p className="text-gray-600">Kliniğimize nasıl ulaşabilirsiniz?</p>
              </div>
            </FadeIn>
            <FadeIn delay={0.1}>
              <div className="rounded-3xl overflow-hidden shadow-xl">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3057.5!2d32.8533!3d39.9784!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMznCsDU4JzQyLjIiTiAzMsKwNTEnMTEuOSJF!5e0!3m2!1str!2str!4v1"
                  width="100%"
                  height="450"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Klinik Konum"
                  className="w-full"
                />
              </div>
            </FadeIn>
          </div>
        </div>
      </section>
    </main>
  );
}
